import { LatestDownloadDisplay } from '@dreamstack/accentro-contentful/src/blocks/LatestDownload'
import { useLocale, useTranslation } from '@dreamstack/i18n'
import { trpc } from '@dreamstack/trpc/client'
import type { FunctionComponent } from 'react'
import { ActionTile } from '../ActionTile'
import { useWerUrl, useWkrUrl } from './getDownloadableFileUrl'

export const NewsHeader: FunctionComponent<
  React.PropsWithChildren<{}>
> = () => {
  const t = useTranslation()

  const werUrl = useWerUrl()
  const wkrUrl = useWkrUrl()

  const locale = useLocale()
  const { data: downloadFinancialReport } = trpc.cms.getLatestDownload.useQuery(
    { locale, type: 'FinancialReport' },
    {
      trpc: { ssr: true },
      staleTime: Infinity,
    }
  )
  const { data: downloadCompanyPresentation } =
    trpc.cms.getLatestDownload.useQuery(
      { locale, type: 'CompanyPresentation' },
      {
        trpc: { ssr: true },
        staleTime: Infinity,
      }
    )

  return (
    <div className="bg-accentroGray-full grid grid-cols-1 md:grid-cols-2 gap-px-24 md:gap-px-40 lg:gap-px-48 lg:grid-cols-4 col-span-full pb-px-64 px-px-24 z-20 md:space-y-0 md:pb-px-80 md:px-px-48 lg:pb-px-128 lg:px-px-64">
      <div>
        {/* TODO: FIXME: broke this with trpc cms ssr */}
        {!!downloadFinancialReport && (
          <LatestDownloadDisplay
            backgroundImageUrl={'/static/images/news-hub-03.jpg'}
            download={downloadFinancialReport}
          />
        )}
      </div>
      <div>
        {!!downloadCompanyPresentation && (
          <LatestDownloadDisplay
            backgroundImageUrl={'/static/images/news-hub-02.jpg'}
            download={downloadCompanyPresentation}
          />
        )}
      </div>
      <div>
        <a href={wkrUrl} target="_blank" rel="noreferrer">
          <ActionTile
            onlyLink
            backgroundImgUrl={'/static/images/houseingcostreport-bg.jpg'}
            heading={t('accentro:downloadableFileTypes.HousingCostReport')}
            caption={''}
          />
        </a>
      </div>
      <a href={werUrl} target="_blank" rel="noreferrer">
        <ActionTile
          onlyLink
          backgroundImgUrl={'/static/images/news-hub-04.jpg'}
          heading={t('accentro:downloadableFileTypes.HomeOwnershipReport')}
          caption={''}
        />
      </a>
    </div>
  )
}
